export const name = 'externalComponent' as const

export const ExternalComponentAPISymbol = Symbol('ExternalComponentAPI')
export const ExternalComponentFetchSymbol = Symbol('ExternalComponentFetch')
export const ExternalComponentLoaderSymbol = Symbol('ExternalComponentLoader')
export const ExternalComponentCssManagerSymbol = Symbol('externalComponentCssManager')
export const ExternalComponentSsrManagerSymbol = Symbol('ExternalComponentSsrManager')
export const ExternalComponentCssApplierSymbol = Symbol('externalComponentCssApplier')

export const ExternalComponentDsApiSymbol = Symbol('externalComponentDsApi')
export const ExternalComponentDsPublicApiSymbol = Symbol('externalComponentDsPublicApi')
export const ExternalComponentLoaderSsrSymbol = Symbol('externalComponentLoaderSsr')
export const ExternalComponentConsentManagerSymbol = Symbol('externalComponentConsentManager')

export const ExternalComponentUiLibProvidersSymbol = Symbol('externalComponentUiLibProviders')

export const ExternalComponentWixCodeUrlGeneratorSymbol = Symbol('externalComponentWixCodeUrlGenerator')
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
